module.exports = __webpack_public_path__ + "static/media/rambutan.99597b63.svg";